import type { ContentfulCallToActionType, ContentfulContactModalType, PageProps, PostPageProps } from "@/types";
import React, { FC, useEffect, useState } from "react";
import { PostAuthor, PostHero } from "../post";
import { A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { ContentManager } from "../content-manager";
import { PostCard } from "../post-card";
import { WhitePaperDownloadResource } from "../resources/white-paper-download-resource";
import { DownloadStrengthenFinancialSystemButton } from "../resources/download-strengthen-financial-system-btn";

export const Posts: FC<PageProps<PostPageProps>> = (props) => {
  
  const [cta, setCta] = useState<any>();
  const [modal, setModal] = useState<any>();

  useEffect(() => {
    if(props.data.post.downloadTheDocumentCta) {
      if(props.data.post.downloadTheDocumentCta.buttonFile) {
        setCta(props.data.post.downloadTheDocumentCta);
      } else {
        const cta: ContentfulCallToActionType = {
          text: [{type: 'paragraph', html: "<p>Download the white paper on de-risking cross-border payments.</p>"}],
          buttonLabel: "Download Whitepaper"
        };
        setCta(cta)
      }
    }

    if(props.data.post.whitePaperDownloadModal) {
      const { whitePaperDownloadModal } = props.data.post;
      const modal: ContentfulContactModalType = {
        title: whitePaperDownloadModal.title,
        subtitle: whitePaperDownloadModal.subtitle,
        content: whitePaperDownloadModal.content
    }
      setModal(modal);
    }

  }, [props.data, props.data.post])

  return (
    <div className="postPage">
      <PostHero {...props.data.post} />
      <ContentManager
        content={props.data.post.content}
        className="postContent"
      />
      {cta && modal && 
        <WhitePaperDownloadResource cta={cta} contentModal={modal} pageSource={props.data.post.title}/>
      }
      {cta && !modal &&
        <DownloadStrengthenFinancialSystemButton buttonLabel={cta.buttonLabel} buttonFile={cta.buttonFile}/>
      }
      {props.data.post.author && <PostAuthor author={props.data.post.author} />}
      {props.data.relatedPosts.length > 0 && (
        <div className="postPage--related">
          <div className="wrapper">
            <div className="postPage--related-title">Related Articles</div>
            <div className="postPage--related-cards">
              {props.data.relatedPosts.map((slide, index) => {
                return (
                  <SwiperSlide key={index} className="postPage--related-slide">
                    <PostCard card={slide} readMore="Read more" theme="dark" />
                  </SwiperSlide>
                );
              })}
            </div>
            <Swiper
              modules={[A11y]}
              slidesPerView={2}
              spaceBetween={64}
              grabCursor
              className="postPage--related-swiper"
            >
              {props.data.relatedPosts.map((slide, index) => {
                return (
                  <SwiperSlide key={index} className="postPage--related-slide">
                    <PostCard card={slide} readMore="Read more" theme="dark" />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </div>
      )}
    </div>
  );
};
